export const ACTIONS = {
    BASKET_ADD_TO_BASKET: 'BASKET_ADD_TO_BASKET',
    BASKET_LOAD_BASKET: 'BASKET_LOAD_BASKET',
    BASKET_REMOVE_FROM_BASKET: 'BASKET_REMOVE_FROM_BASKET',
    STATUS_SET_LOADING_STATUS: 'STATUS_SET_LOADING_STATUS',
    STATUS_SET_ERROR_STATUS: 'STATUS_SET_ERROR_STATUS',
    TRAVEL_SEARCH_SAVE_SEARCH_RESULT: 'TRAVEL_SEARCH_SAVE_SEARCH_RESULT',
};

export const setLoadingStatus = (loading) => ({ type: ACTIONS.STATUS_SET_LOADING_STATUS, payload: loading });
export const setErrorStatus = (error) => ({ type: ACTIONS.STATUS_SET_ERROR_STATUS, payload: error });
export const saveSearchResult = (searchResult, key) => ({ type: ACTIONS.TRAVEL_SEARCH_SAVE_SEARCH_RESULT, payload: searchResult, key });
export const addToBasket = (basket) => ({ type: ACTIONS.BASKET_ADD_TO_BASKET, payload: basket });
export const loadBasket = (basket) => ({ type: ACTIONS.BASKET_LOAD_BASKET, payload: basket });
export const removeFromBasket = (basket) => ({ type: ACTIONS.BASKET_REMOVE_FROM_BASKET, payload: basket });
